// Fix for inline quantity selector functionality
(function() {
  function initQuantitySelector() {
    const quantityInput = document.querySelector('.product-form__cart-row input[name="quantity"]');
    const decreaseBtn = document.querySelector('.product-form__cart-row [data-action="decrease-picker-quantity"]');
    const increaseBtn = document.querySelector('.product-form__cart-row [data-action="increase-picker-quantity"]');
    
    if (!quantityInput || !decreaseBtn || !increaseBtn) return;
    
    decreaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    
    increaseBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = currentValue + 1;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
    
    // Ensure input only accepts numbers
    quantityInput.addEventListener('input', function(e) {
      const value = parseInt(this.value) || 1;
      if (value < 1) {
        this.value = 1;
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuantitySelector);
  } else {
    initQuantitySelector();
  }
  
  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', initQuantitySelector);
})();
